const CARD = {
  R:   18,   // border-radius
  GAP: 16,   // gap between reverse-card notch and mockup image
};

function buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`,
    ].join(' ');
}
function getCardConfig(W) {
    if (W < 640) {
        return {
            R: 10,
            GAP: 0,
            mapWidthRatio: 0.48,
            mapHeightRatio: 0.51,
            notch: false,   // ← plain rounded rect, no image cutout
        };
    }
    if (W < 900) {
        return { R: 18, GAP: 16, mapWidthRatio: 0.5, mapHeightRatio: 0.5, notch: true };
    }
    return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true };
}
function buildReversePath(W, H, CARD) {
    const cfg = getCardConfig(W);
    const MAP_W = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H = Math.min(W * cfg.mapHeightRatio * 17 / 16 - cfg.GAP, H - cfg.GAP * 2);

    if (!cfg.notch) {
        // Mobile: simple rounded rect, no notch geometry needed
        return { d: buildRectPath(W, H, cfg.R), MAP_W, MAP_H, MAP_LEFT: 0 };
    }

    const NOTCH_RIGHT  = MAP_W + cfg.GAP;   // right edge of the cut-out
    const NOTCH_BOTTOM = MAP_H + cfg.GAP;   // bottom edge of the cut-out

    const d = [
        `M ${NOTCH_RIGHT + cfg.R} 0`,                                            // start: top edge, right of notch
        `L ${W - cfg.R} 0`,                                                       // → top-right
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W} ${cfg.R}`,                               // arc: top-right corner
        `L ${W} ${H - cfg.R}`,                                                    // ↓ right edge
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W - cfg.R} ${H}`,                           // arc: bottom-right corner
        `L ${cfg.R} ${H}`,                                                        // ← bottom edge
        `A ${cfg.R} ${cfg.R} 0 0 1 0 ${H - cfg.R}`,                              // arc: bottom-left corner
        `L 0 ${NOTCH_BOTTOM + cfg.R}`,                                            // ↑ left edge (stops below notch)
        `A ${cfg.R} ${cfg.R} 0 0 1 ${cfg.R} ${NOTCH_BOTTOM}`,                    // arc: notch bottom-left (convex ↗)
        `L ${NOTCH_RIGHT - cfg.R} ${NOTCH_BOTTOM}`,                              // → notch floor
        `A ${cfg.R} ${cfg.R} 0 0 0 ${NOTCH_RIGHT} ${NOTCH_BOTTOM - cfg.R}`,      // arc: notch bottom-right (concave ↑)
        `L ${NOTCH_RIGHT} ${cfg.R}`,                                              // ↑ notch right wall
        `A ${cfg.R} ${cfg.R} 0 0 1 ${NOTCH_RIGHT + cfg.R} 0 Z`,                  // arc: notch top-right (concave →)
    ].join(' ');

    return { d, MAP_W, MAP_H, MAP_LEFT: 0 };   // image card sits at x=0
}

    const serviceDesc = document.querySelector('.service-description');
    const imgCard = document.querySelector('.oc-mockup-img');
    const ocInfoSection = document.querySelector('.oc-info-section');

    let prevIsMobile = null;

function reparentImgCard(isMobile) {
    if (isMobile === prevIsMobile) return;
    prevIsMobile = isMobile;

    if (isMobile) {
        imgCard.style.position = 'static';
        imgCard.style.alignSelf = 'center';
        imgCard.style.background = "none";
        imgCard.style.boxShadow = "none";
        ocInfoSection.insertBefore(imgCard, ocInfoSection.children[2]);
    } else {
        serviceDesc.appendChild(imgCard);
        imgCard.style.position = 'absolute';
        imgCard.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        imgCard.style.boxShadow = "-8px -8px 20px var(--shadow-light), 8px 8px 20px var(--shadow-dark), inset -5px -5px 15px var(--shadow-light), inset 5px 5px 10px #aeaec040";
    }
}

    function applyGeometry(W, H) {
        const { d, MAP_W, MAP_H, MAP_LEFT } = buildReversePath(W, H, CARD);

        // Reverse card clip
        const reverseCardRoot = document.querySelector('.oc-reverse-card');
        if (reverseCardRoot) reverseCardRoot.style.clipPath = `path("${d}")`;

        // Single SVG path — convex-bubble filter only
        const shadowPath = document.getElementById('oc-insetLightPath');
        if (shadowPath) shadowPath.setAttribute('d', d);

        // SVG canvas sizing
        const svg = document.getElementById('oc-inset-svg');
        if (svg) {
            svg.setAttribute('width',  W);
            svg.setAttribute('height', H);
        }

        // Mockup image position + size
        if (imgCard) {
            imgCard.style.left   = `${MAP_LEFT}px`;
            imgCard.style.width  = `${MAP_W}px`;
            imgCard.style.height = `${MAP_H}px`;
        }
    }
const ro = new ResizeObserver(entries => {
    const { width, height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    reparentImgCard(isMobile);
    applyGeometry(width, height); // always runs now
});

ro.observe(serviceDesc);
